export default "__VITE_ASSET__DOpZiF5s__"